<lib-employee-info [employeeInfo]="data"></lib-employee-info>
